import React, { FunctionComponent } from "react";
import Select from "react-select";
import { Grade } from "../../../../../../store/groups/types";
import { GradeLevels } from "../../../../../../store/onboarding/types";
import { SchoolOption } from "../hooks/useEquityBenchmarkData";

type OwnProps = {
  selectedGradeKey: Grade;
  selectedSchool: number | undefined;
  schoolOptions: SchoolOption[];
  onGradeLevelChange: (value: any) => void;
  onSchoolChange: (value: any) => void;
};

type Props = OwnProps;

/**
 * Renders the Grade/School filter selects for the Equity Benchmarks modal.
 * Extracted from EquityBenchmarksModalContent as-is (no logic changes).
 */
const EquityBenchmarkFilters: FunctionComponent<Props> = (props) => {
  const { selectedGradeKey, selectedSchool, schoolOptions, onGradeLevelChange, onSchoolChange } = props;

  const selectedGrade = GradeLevels.find((gl) => gl.value === selectedGradeKey);

  return (
    <div className="row my-2 pt-2">
      <div className="col-3 d-flex mb-2 align-items-center">
        <label htmlFor="equity-benchmark-grade-select" className="font-weight-bold mr-2">
          Grade:{" "}
        </label>
        <Select
          inputId="equity-benchmark-grade-select"
          className="dataFiltersSelect w-100"
          value={selectedGrade}
          options={GradeLevels}
          onChange={onGradeLevelChange}
        />
      </div>
      <div className="col-9 d-flex mb-2  align-items-center">
        <label htmlFor="equity-benchmark-school-select" className="font-weight-bold mr-2">
          School:{" "}
        </label>
        <Select
          inputId="equity-benchmark-school-select"
          className="dataFiltersSelect w-100"
          value={schoolOptions.find((school) => school.value == selectedSchool)}
          options={schoolOptions}
          onChange={onSchoolChange}
        />
      </div>
    </div>
  );
};

export default EquityBenchmarkFilters;
